export default function FlightDeployment({
                                             title = "Flight Clearance & Deployment",
                                             badge = "SEAMLESS MOBILIZATION",
                                             description = "Our dedicated operations team manages full flight logistics, visa clearances, and airport departures ensuring workers arrive safely and on schedule.",
                                             features = [
                                                 { icon: "fa fa-passport", text: "BMET Smartcard & Visa Stamping Clearance" },
                                                 { icon: "fa fa-plane-departure", text: "Group Ticketing & Pre-Departure Briefing" },
                                                 { icon: "fa fa-headset", text: "Flight Arrival Coordination with Employers" }
                                             ],
                                             imageSrc = "54.jpg",
                                             reverse = false
                                         }) {
    return (
        <section className="flight-deployment-area pt-60 pb-80 position-relative overflow-hidden"
            style={{
                backgroundImage: 'url("48.png")', // আপনার প্লেন বা এভিয়েশন ব্যাকগ্রাউন্ড ইমেজের পাথ এখানে দিন
                backgroundSize: 'contain',
                backgroundPosition: 'left center',
                backgroundRepeat: 'no-repeat',
                backgroundColor: '#ffffff'
            }}
        >
            <div className="container position-relative" style={{ zIndex: 2 }}>
                <div className={`row align-items-center g-5 ${reverse ? 'flex-row-reverse' : ''}`}>
                    {/* Left Text Content */}
                    <div className="col-lg-6">
                        <div className="deployment-content">
                            {badge && (
                                <span className="badge bg-dark text-white  border px-3 py-2 mb-3 fw-semibold rounded-pill">
                                    {badge}
                                </span>
                            )}
                            <h2 className="fw-bold mb-3" style={{ color: '#0f172a' }}>{title}</h2>
                            {description && (
                                <p className="text-dark mb-4" align="justify">
                                    {description}
                                </p>
                            )}

                            <ul className="list-unstyled">
                                {features.map((item, index) => (
                                    <li key={index} className="d-flex align-items-center mb-3">
                                        <div className="flex-shrink-0 text-dark fs-5 me-3">
                                            <i className={item.icon || "fa fa-check-circle"}></i>
                                        </div>
                                        <span className="text-dark fw-medium">{item.text}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    {/* Right Image Side */}
                    <div className="col-lg-6">
                        <div className="deployment-img text-center">
                            <img
                                src={imageSrc}
                                alt={title}
                                className="img-fluid w-100 shadow-sm"
                                style={{ borderRadius: '40px', objectFit: 'cover', maxHeight: '480px' }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}